import React, { useState } from 'react';
import { Modal, Form, Input, message } from 'antd';
import { User } from '../types';
import { userAPI } from '../services/api.ts';

interface ChangePasswordModalProps {
  visible: boolean;
  onClose: () => void;
  user: User;
}

const ChangePasswordModal: React.FC<ChangePasswordModalProps> = ({
  visible,
  onClose,
  user,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: { password: string; confirmPassword: string }) => {
    if (values.password !== values.confirmPassword) {
      message.error('Le password non coincidono');
      return;
    }

    setLoading(true);
    try {
      await userAPI.changeUserPassword(user.id, values.password);
      message.success(`Password cambiata con successo per l'utente ${user.username}`);
      form.resetFields();
      onClose();
    } catch (error: any) {
      const errorMessage = error.response?.data?.detail || 'Errore nel cambio password';
      message.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      title={`Cambia Password - ${user.username}`}
      open={visible}
      onCancel={handleCancel}
      onOk={() => form.submit()}
      confirmLoading={loading}
      destroyOnClose
      className="no-uppercase-modal"
    >
      <Form
        form={form}
        layout="vertical"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="password"
          label="Nuova Password"
          rules={[
            { required: true, message: 'La password è obbligatoria' },
            { min: 10, message: 'La password deve avere almeno 10 caratteri' },
            { pattern: /^(?=.*[A-Za-z])(?=.*\d).+$/, message: 'La password deve contenere almeno una lettera e una cifra' }
          ]}
        >
          <Input.Password placeholder="Inserisci la nuova password" />
        </Form.Item>
        
        <Form.Item
          name="confirmPassword"
          label="Conferma Password"
          dependencies={['password']}
          rules={[
            { required: true, message: 'Conferma la password' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Le password non coincidono'));
              },
            }),
          ]}
        >
          <Input.Password placeholder="Conferma la nuova password" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ChangePasswordModal;